module.exports = __webpack_public_path__ + "img/download_scr_1.76060679.png";